import { Colors } from '../../../constants';

export const waiverFormStyles = () => ({
	root: {
		background: Colors.black,
		color: Colors.white,
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		maxWidth: { xs: '100%', md: '565px' },
		width: '100%',
		pt: '32px',
		px: '24px',
		height: '100%',
		marginLeft: 'auto',
		overflowY: 'auto',
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: '2px',
		minHeight: '48px',
		position: 'relative',
	},
	headerTitle: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '24px',
		fontWeight: '700',
		lineHeight: '29px',
		color: Colors.white,
	},
	closeButton: {
		minWidth: '48px',
		minHeight: '48px',
		position: 'absolute',
		top: '0',
		right: '0',
		border: `1px solid ${Colors.white_a40}`,
	},
	closeIcon: {
		width: '24px',
		height: '24px',
		color: Colors.white,
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		flex: 1,
	},
	footer: {
		py: '12px',
		display: 'flex',
		justifyContent: 'center',
	},
	footerButton: {
		minWidth: '300px',
	},
	radioGroup: {
		paddingBottom: '7px',
		borderBottom: '1px solid #FFFFFF1A',

		'& .MuiRadioGroup-root': {
			gap: '62px'
		}
	}
});
